import "./namespace.js";

Object.assign(window.Sparkle.Client, {
  jstTemplate(path) {
    const clientPath = jQuery(document.head).find('meta[name="client-jst-path"]').attr("content");
    return JST[`${clientPath}/${path}`] || JST[path];
  },

  renderJstTemplate(path, context = {}) {
    const template = Sparkle.Client.jstTemplate(path);
    return template(context);
  },
});
